import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-send-ticket',
    templateUrl: './send-ticket.component.html',
    styleUrls: ['./send-ticket.component.scss']
})
export class SendTicketComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }
}
